<div class="wrapper">
  <div class="action-section flex flex-row-reverse my-[20px] w-full gap-[20px]">
    <app-primary-button
      (handleClick)="create()"
      [isDisabled]="!canManageProjectMembers"
      class="!w-[150px]"
      > Create </app-primary-button>
  </div>

  @if (isOrgAdmin && !isDwrReportingHierarchyEnabled) {
    <div class="hierarchy-note mb-[20px]" [attr.data-dwrReportingHierarchyEnabled]="isDwrReportingHierarchyEnabled">
      Enable DWR reporting hierarchy in project settings to assign reporting managers.
    </div>
  }

  <div class="list-section">
    <div class="account-list-table flex flex-col gap-[40px]">
      @if (dataSource?.length) {
        <div class="bit-items-table">
          <table [dataSource]="dataSource" class="mat-elevation-z8 table" mat-table>
            <ng-container matColumnDef="name">
              <th *matHeaderCellDef mat-header-cell>Name</th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">{{ row?.name || row?.first_name + ' ' + row?.last_name }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="email">
              <th *matHeaderCellDef mat-header-cell>Email</th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">{{ row?.email }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="phone">
              <th *matHeaderCellDef mat-header-cell>Phone</th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">{{ row?.phone }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="roleName">
              <th *matHeaderCellDef mat-header-cell>Role</th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">{{ row?.roleName || row?.role_name || row?.role }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="reportsTo">
              <th *matHeaderCellDef mat-header-cell>Reports to</th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">{{ getReportsToName(row) }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th *matHeaderCellDef mat-header-cell></th>
              <td *matCellDef="let row" mat-cell>
                @if (canEditMember(row)) {
                  <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                    <mat-icon>more_horiz</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="deleteUser(row, $event)">
                      <mat-icon svgIcon="trash"></mat-icon>
                      <span>Remove</span>
                    </button>
                  </mat-menu>
                }
              </td>
            </ng-container>
            <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
            <tr
              (click)="rowClicked(row)"
              *matRowDef="let row; columns: displayedColumns"
              [class.highlighted-row]="row === selectedRow"
              [class.readonly-row]="!canEditMember(row)"
              mat-row
            ></tr>
          </table>
        </div>
      }

      @if (!dataSource?.length) {
        <div class="no-data mt-[80px]">No data available.</div>
      }

      @if (totalRecords > 0) {
        <app-paginator
          (pageChanged)="onPageChanged($event)"
          [itemsPerPage]="pagination?.pageSize"
          [maxVisiblePages]="5"
          [totalItems]="totalRecords"
          class="paginator"
          />
      }
    </div>
  </div>
</div>
